
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ReceiptDetailsDialog extends _Ext.ItemEditorDialog<ReceiptDetailsRow> {
        protected getFormKey() { return ReceiptDetailsForm.formKey; }
        protected getLocalTextPrefix() { return ReceiptDetailsRow.localTextPrefix; }
        protected getDeletePermission() { return ReceiptDetailsRow.deletePermission; }
        protected getInsertPermission() { return ReceiptDetailsRow.insertPermission; }
        protected getUpdatePermission() { return ReceiptDetailsRow.updatePermission; } 
        protected form = new ReceiptDetailsForm(this.idPrefix);
        public ECommExchangerate;
        constructor() {
            super();

            this.element.width(250);
            q.setTextRightAlign(this.form.Amount);
            this.form.Mode.changeSelect2(e => {
                var ledger = OMS.PaymentModeRow.getLookup().itemById[this.form.Mode.value];
                this.form.LedgerId.value = ledger.LedgerId.toString();

                Serenity.EditorUtils.setReadOnly(this.form.LedgerId, true);
                if (ledger.Type == 280) { //For Gift Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                    //q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, true);
                }
                else if (ledger.Type == 283) { //For Gift Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                    //q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, false);
                }
                else if (ledger.Type == 281) {//For Cheque
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, false);
                    q.hideField(this.form.ChequeNo, false);
                    q.hideField(this.form.BankId, false);

                 //   q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, true);
                }
                else if (ledger.Type == 284) {//For Scheme Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                    //q.hideField(this.form.Scheme, false);
                    q.hideField(this.form.RefNo, true);
                    //this.form.Scheme.cascadeField = "CustomerId";
                    var poscustomerid = (this.parentEditor.parentDialog as ReceiptDialog).form.POSCustomerId;
                    if (poscustomerid == undefined) {
                        Q.alert('Please Select Customer');
                        this.dialogClose();
                    }
                }
                this.form.RefNo.value = "";
             //   this.form.Scheme.value = "";

            });
            this.form.RefNo.changeSelect2(e => {
                var details = Retail.GiftVoucherItemDetailsRow.getLookup().items.filter(x => x.UniqueNo == this.form.RefNo.value);
                amount = 0;
                for (var i = 0; i < details.length; i++) {
                    amount += details[i].Amount;
                }
                this.form.Amount.value = amount;
                if (details[0].IsPartial) {

                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                } else { Serenity.EditorUtils.setReadOnly(this.form.Amount, false); }
            });
            this.form.Amount.changeSelect2(e => {
                if (this.form.Mode.value == "283") {
                    if (this.form.Amount.value > amount) {
                        Q.alert('Gift Voucher Limit Exceded');
                        this.form.Amount.value = amount;
                        return;
                    }
                }
            });
            //this.form.Scheme.changeSelect2(e => {
            //    var schemedetails = Scheme.SchemeEnrollmentRow.getLookup().itemById[this.form.Scheme.value];
            //    var totalamount = schemedetails.SchemeAmount + schemedetails.BonusValue;
            //    this.form.Amount.value = totalamount;
            //});
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.Mode.value != "") {
                var ledger = OMS.PaymentModeRow.getLookup().itemById[this.form.Mode.value];
                if (ledger.Type == 283) {
                    var details = Retail.GiftVoucherItemDetailsRow.getLookup().items.filter(x => x.UniqueNo == this.form.RefNo.value);
                    amount = 0;
                    for (var i = 0; i < details.length; i++) {
                        amount += details[i].Amount;
                    }
                }
                else if (ledger.Type == 283) {
                   // q.hideField(this.form.Scheme, false);
                }

                if (ledger.Type == 280) { //For Gift Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                   // q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, true);
                }
                else if (ledger.Type == 283) { //For Gift Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                 //   q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, false);
                }
                else if (ledger.Type == 281) {//For Cheque
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, false);
                    q.hideField(this.form.ChequeDate, false);
                    q.hideField(this.form.ChequeNo, false);
                    q.hideField(this.form.BankId, false);

                   // q.hideField(this.form.Scheme, true);
                    q.hideField(this.form.RefNo, true);
                }
                else if (ledger.Type == 284) {//For Scheme Voucher
                    Serenity.EditorUtils.setReadOnly(this.form.Amount, true);
                    q.hideField(this.form.ChequeDate, true);
                    q.hideField(this.form.ChequeNo, true);
                    q.hideField(this.form.BankId, true);
                 //   q.hideField(this.form.Scheme, false);
                    q.hideField(this.form.RefNo, true);
                    //this.form.Scheme.cascadeField = "CustomerId";
                    var poscustomerid = (this.parentEditor.parentDialog as ReceiptDialog).form.POSCustomerId;
                    if (poscustomerid == undefined) {
                        Q.alert('Please Select Customer');
                        this.dialogClose();
                    }
                }


            } else {
               // q.hideField(this.form.Scheme, true);
                q.hideField(this.form.ChequeNo, true);
                q.hideField(this.form.ChequeDate, true);
                q.hideField(this.form.BankId, true);
            }
        }


    }
}